// Factories for creating filter validation functions
import moment from 'moment';

type RawValidator = (input: string) => any;

type HistoryAction = {
  historyAction: 'push' | 'replace';
};
export type Validator = RawValidator & HistoryAction;

const funcWithProps =
  <Props extends {}, Func extends Function>(props: Props) =>
  (func: Func) => {
    const f = func as Func & Props;
    //@ts-ignore: intentionally injecting properties to a function
    Object.keys(props).forEach((key) => (f[key] = props[key]));
    return f;
  };

export const toPushHistory: (arg0: RawValidator) => Validator = funcWithProps<
  HistoryAction,
  RawValidator
>({ historyAction: 'push' });

export const toReplaceHistory: (arg0: RawValidator) => Validator =
  funcWithProps<HistoryAction, RawValidator>({
    historyAction: 'replace',
  });

// text filters change should call history.replace, since creating one history
//   record per filter change would likely spam the history stack
export const freeText = (): Validator =>
  toReplaceHistory((text: string) => text);

export const multiFromArray = (values: Array<string>): Validator =>
  toPushHistory(
    (value: string) =>
      value &&
      value
        .split(',')
        .filter((val) => values.includes(val))
        .join(','),
  );

export const oneOfArray = (values: Array<string>): Validator =>
  toPushHistory((value: string) => (values.includes(value) ? value : null));

export const validDate = (getDefault: () => string): Validator =>
  toPushHistory((value: string) => {
    const filter = moment(value);
    if (filter.isValid()) {
      return value;
    } else {
      return getDefault();
    }
  });
